// Componente Card - Tarjeta reutilizable
// Basado en los estilos del mockup para productos y categorías

import './Card.css'

/**
 * Componente Card
 * Tarjeta reutilizable para productos, categorías, etc.
 * @param {Object} props - Propiedades del componente
 * @param {React.ReactNode} props.children - Contenido de la tarjeta
 * @param {string} props.className - Clases CSS adicionales
 * @param {Function} props.onClick - Función a ejecutar al hacer clic
 * @param {string} props.variant - Variante: 'default', 'product', 'category'
 */
function Card({
  children,
  className = '',
  onClick,
  variant = 'default'
}) {
  // Construir clases CSS basadas en las props
  const cardClasses = `card card-${variant} ${className}`.trim()

  return (
    <div 
      className={cardClasses}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={onClick ? (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          onClick()
        }
      } : undefined}
    >
      {children}
    </div>
  )
}

export default Card

